<template>
  <v-app>
    <Layout />
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import Layout from "@/components/Layout";

export default {
  name: "App",
  components: { Layout },
};
</script>

<style lang="scss">
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  box-shadow: 0 0 0 30px white inset !important;
}
.custom-checkbox-label .v-label {
  font-size: 12px;
  color: #000000 !important;
  line-height: 14px !important;
}
</style>
